"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _toolbar = require("../../constants/toolbar");

var _MoreMenuContent = _interopRequireDefault(require("./MoreMenuContent"));

var _StyleProtectedUIDropdown = _interopRequireDefault(require("../style-protected/StyleProtectedUIDropdown"));

var _withDisabledContext = _interopRequireDefault(require("../hoc/withDisabledContext"));

var MoreMenu =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MoreMenu, _React$Component);

  function MoreMenu() {
    (0, _classCallCheck2.default)(this, MoreMenu);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MoreMenu).apply(this, arguments));
  }

  (0, _createClass2.default)(MoreMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          dropdownClassName = _this$props.dropdownClassName,
          onOpenComplete = _this$props.onOpenComplete,
          disabled = _this$props.disabled,
          toolbarWidth = _this$props.toolbarWidth,
          menuItems = _this$props.menuItems;
      return _react.default.createElement(_StyleProtectedUIDropdown.default, {
        use: "unstyled",
        buttonText: _I18n.default.text(_toolbar.TOOLBAR_I18N_PREFIX + ".moreMenu"),
        buttonUse: "transparent",
        buttonClassName: className,
        closeOnMenuClick: false,
        dropdownClassName: dropdownClassName,
        autoPlacement: "horiz",
        _useMutationObserver: true,
        placement: "bottom left",
        minMenuWidth: 0,
        animateOnToggle: false,
        onOpenComplete: onOpenComplete,
        disabled: disabled
      }, _react.default.createElement(_MoreMenuContent.default, {
        toolbarWidth: toolbarWidth,
        menuItems: menuItems
      }));
    }
  }]);
  return MoreMenu;
}(_react.default.Component);

MoreMenu.propTypes = {
  menuItems: _react.PropTypes.array.isRequired,
  toolbarWidth: _react.PropTypes.number.isRequired,
  className: _react.PropTypes.string,
  dropdownClassName: _react.PropTypes.string,
  onOpenComplete: _react.PropTypes.func,
  disabled: _react.PropTypes.bool
};

var _default = (0, _withDisabledContext.default)(MoreMenu);

exports.default = _default;
module.exports = exports.default;